export default {
  author: 'Origin',
  name: 'Origin',
  cookies: {
    lang: 'origin_lang',
  },
  locale: ['fr', 'en'],
  loader: true,
  mode: 'out-in',
  prefixRoute: false,
  cms: false,
}
